import { getCore, postCore, patchCore, delCore } from "../../utils/httpInterceptor";

class SavedFilterService {
  static async list(entityKey) {
    return getCore(`/api/core/saved-filters/${encodeURIComponent(entityKey)}`);
  }

  static async create(payload) {
    return postCore("/api/core/saved-filters", payload);
  }

  static async update(id, payload) {
    return patchCore(`/api/core/saved-filters/${id}`, payload);
  }

  static async remove(id) {
    return delCore(`/api/core/saved-filters/${id}`);
  }
}

export default SavedFilterService;
